import { useAppSelector } from "@/hooks";
import { currentUser } from "@/store/appSlice";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const Sidebar = () => {
  const location = useLocation();
  const user = useAppSelector(currentUser);
  const [activePath, setActivePath] = useState<string>("");

  useEffect(() => {
    setActivePath(location.pathname);
  }, [location.pathname]);

  const isActive = (path: string) => activePath === path ? "mm-active" : "";

  return (
    <div className="deznav">
      <div className="deznav-scroll">
        {
          user?.claims?.isAdmin && (
            <ul className="metismenu" id="menu">
              <li className={isActive("/dashboard") || isActive("/")}>
                <a className="ai-icon" href="/dashboard" aria-expanded="false">
                  <i className="flaticon-381-networking"></i>
                  <span className="nav-text">ダッシュボード</span>
                </a>
              </li>
              <li className={isActive("/users")}>
                <a className="ai-icon" href="/users" aria-expanded="false">
                  <i className="flaticon-381-user"></i>
                  <span className="nav-text">ユーザー管理</span>
                </a>
              </li>
              <li className={location.pathname.includes("/content") ? "mm-active" : ""}>
                <a className="has-arrow ai-icon" href="#" aria-expanded={location.pathname.includes("/content")}>
                  <i className="flaticon-381-book"></i>
                  <span className="nav-text">学習コンテンツ管理</span>
                </a>
                <ul aria-expanded="false">
                  <li className={isActive("/content")}>
                    <a href="/content">コンテンツ管理トップ</a>
                  </li>
                  <li className={isActive("/content/dictation-courses")}>
                    <a href="/content/dictation-courses">ディクテーションコース</a>
                  </li>
                  <li className={isActive("/content/sentences")}>
                    <a href="/content/sentences">センテンス管理</a>
                  </li>
                  <li className={isActive("/content/word-courses")}>
                    <a href="/content/word-courses">単語コース</a>
                  </li>
                  <li className={isActive("/content/words")}>
                    <a href="/content/words">単語・熟語管理</a>
                  </li>
                </ul>
              </li>
              <li>
                <a className="ai-icon" href="#" aria-expanded="false">
                  <i className="flaticon-381-controls-3"></i>
                  <span className="nav-text">学習進捗と統計</span>
                </a>
              </li>
              <li className={isActive("/notifications")}>
                <a className="ai-icon" href="/notifications" aria-expanded="false">
                  <i className="flaticon-381-internet"></i>
                  <span className="nav-text">通知管理</span>
                </a>
              </li>
              <li className={location.pathname.includes("/settings") ? "mm-active" : ""}>
                <a className="has-arrow ai-icon" href="#" aria-expanded={location.pathname.includes("/settings")}>
                  <i className="flaticon-381-settings-2"></i>
                  <span className="nav-text">各種設定</span>
                </a>
                <ul aria-expanded="false">
                  <li className={isActive("/settings/admins")}>
                    <a href="/settings/admins">管理者管理</a>
                  </li>
                  <li className={isActive("/settings/service-setting")}>
                    <a href="/settings/service-setting">サービス管理</a>
                  </li>
                  <li className={isActive("/settings/update-password")}>
                    <a href="/settings/update-password">パスワード変更</a>
                  </li>
                </ul>
              </li>
            </ul>
          )
        }
        {
          (!user?.claims?.isAdmin && user?.claims?.isUserManageAdmin) || (!user?.claims?.isAdmin && user?.claims?.isContentManageAdmin) ? (
            <ul className="metismenu" id="menu">
              {
                !user?.claims?.isAdmin && user?.claims?.isUserManageAdmin && <li className={isActive("/users")}>
                  <a className="ai-icon" href="/users" aria-expanded="false">
                    <i className="flaticon-381-user"></i>
                    <span className="nav-text">ユーザー管理</span>
                  </a>
                </li>
              }
              {
                !user?.claims?.isAdmin && user?.claims?.isContentManageAdmin &&
                <li className={location.pathname.includes("/content") ? "mm-active" : ""}>
                  <a className="has-arrow ai-icon" href="#" aria-expanded={location.pathname.includes("/content")}>
                    <i className="flaticon-381-book"></i>
                    <span className="nav-text">学習コンテンツ管理</span>
                  </a>
                  <ul aria-expanded="false">
                    <li className={isActive("/content")}>
                      <a href="/content">コンテンツ管理トップ</a>
                    </li>
                    <li className={isActive("/content/dictation-courses")}>
                      <a href="/content/dictation-courses">ディクテーションコース</a>
                    </li>
                    <li className={isActive("/content/word-courses")}>
                      <a href="/content/word-courses">単語コース</a>
                    </li>
                  </ul>
                </li>
              }
              <li className={isActive("/settings/update-password")}>
                <a className="has-arrow ai-icon" href="#" aria-expanded="false">
                  <i className="flaticon-381-settings-2"></i>
                  <span className="nav-text">各種設定</span>
                </a>
                <ul aria-expanded="false">
                  <li>
                    <a href="/settings/update-password">パスワード変更</a>
                  </li>
                </ul>
              </li>
            </ul>
          ) : null
        }
      </div>
    </div>
  );
};

export default Sidebar;
